import React, { useEffect } from 'react';
import {PageContainer, GuideAppContainer, RenderOnlyFor, PageNavigation, NeuroMessage, useNeuroState, useDispatch, usePages} from '@ignitesales/neuro-application/src/neuro-guide';
import {useToastNofitications} from '@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications';
import {checkAndGoToDeepLink} from './actions/royal-consumer-online-actions';
import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import DetailsPage from './components/pages/DetailsPage';
import Header from './components/Header';
import Footer from './components/Footer';

const App = () => {
  const dispatch = useDispatch();
  const { redirectToPath, redirectType, royalAppIsReady } = useNeuroState();
  const { isLoadingNextPage } = usePages();

  useEffect(() => dispatch(checkAndGoToDeepLink()), []);

  useEffect(() => {
    if(redirectToPath){ window.location.href = redirectToPath; }
  }, [redirectToPath]);

  useEffect(() => {
    if(!isLoadingNextPage) {
      window.scrollTo(0, 0)
    }
  }, [isLoadingNextPage])

  return royalAppIsReady ? <GuideAppContainer>
    { redirectToPath && <div className="redirectLoadingOverlay animated fadeIn"><NeuroMessage id={`redirectMessage.${redirectType}`} /></div>}
    <Header/>
    <PageContainer
      LandingPage={LandingPage}
      SurveyPage={SurveyPage}
      SummaryPage={SummaryPage}
      DetailsPage={SummaryPage}
    />
    <RenderOnlyFor forSurveyPage>
      <PageNavigation
        toastTimeout={ 2000 }
      />
    </RenderOnlyFor>
    <Footer/>
  </GuideAppContainer> : null;
};

export default App;
